import { Component, OnInit, Input } from '@angular/core';
import { BaseComponent } from '../../Library/BaseComponent';
import { ComplainRegister, ComplainSearch } from '../../Models/RequestModels';
import { MasterDataService } from '../../Services/MasterDataService';
import { ActivatedRoute, Router } from '@angular/router';
import { CallStatuses } from '../../Models/EnumModels';
import { PMSService } from '../../Services/PMSService';
import { GuestLookup } from '../../Models/ResponseModels';
import * as _ from 'lodash';
import { ComplainService } from '../../Services/ComplainService';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';

@Component({
    selector: 'PendingCalls',
    templateUrl: './PendingCalls.html'
})

export class PendingCalls extends BaseComponent implements OnInit {
    Model: any;
    _LocationId: number;
    DateFormat: string;

    constructor(public translate: TranslateService, public toastr: ToastrService, public route: ActivatedRoute, public router: Router, public masterService: MasterDataService, protected pmsService: PMSService, private complainService: ComplainService) {
        super(translate, toastr, route, router, masterService);
    }

    ngOnInit(): void {
        this.DateFormat = this.masterService.GetPropertyDateFormat(null);
    }

    @Input() set LocationId(LocationId: number) {
        this._LocationId = LocationId;
        //console.info(value);

        if (this._LocationId == null) {
            this.Model = null;
            return;
        }

        this.SetData();
    }

    SetData(): void {
        let req = new ComplainSearch();
        req.Locations = [this._LocationId];
        req.PageNumber = 1;
        req.PageSize = 15;
        req.OrderBy = "REPORTEDAT";

        this.IsSubmitting = true;

        this.complainService.Complain_Search(req).then(data => {
            //console.info(data);
            this.Model = data;
            this.IsSubmitting = false;
        }).catch(reason => {
            this.IsSubmitting = false;
        })
    }
}
